//Make sure controller & component names are different from portal's!
(function (ng, app) {
    app.config([
        '$stateProvider',
        function ($stateProvider) {
            $stateProvider.state('Onboarding.Agreement',
                {
                    url: '/Agreement?envelopeId',
                    component: 'agreementComponent',
                    params: {
                        envelopeId: null
                    },
                });
        }
    ]);

    app.component('agreementComponent', {
        templateUrl: 'App.Onboarding/States/Agreement/Agreement.template.html',
        controller: 'AgreementController',
        bindings: {
            docIsSigned: "=",
            masterAdvisorAgreementRequiredRecord: "<",
            isRedirecting: "=",
            signError: "=",
            user: "<",
            userGroup: "<",
            userMasterAdvisorAgreement: "<"
        }
    });

    app.controller('AgreementController', AgreementController);

    AgreementController.$inject = ['agreementsApi', '$location', 'permissionService', '$stateParams', '$window'];

    function AgreementController(agreementsApi, $location, permissionService, $stateParams, $window) {
        var $ctrl = this;
        window.a = this;

        ng.extend($ctrl, {
            ui: {
                //docIsigned: $ctrl.userMasterAdvisorAgreement === null ? false : true,
                loading: false
                //,redirecting: false
                //,showIframe: false
            }
        });

        $ctrl.createAgreement = function () {
            $ctrl.isRedirecting = true;

            // TODO: replace with endpoint for Onbaording 
            agreementsApi.initMasterAdvisorAgreement($ctrl.workflow)
                .then(function (result) {
                    //$ctrl.ui.showIframe = true;
                    console.log(result);
                    // TODO complete process for new iframe completion
                    // TODO: add ng-disabled to next button to disable when not signed or skipped
                    //$window.open(result, 'MaaIframe');
                    $window.open(result, '_self');
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.data === 'An agreement for this user already exists.') {
                        $ctrl.docIsSigned = true;
                        //$ctrl.ui.showIframe = false;
                    }
                    $ctrl.signError = true;
                })
                .finally(function () {
                    $ctrl.isRedirecting = false;
                });
        };

        $ctrl.$onInit = function () {
            $ctrl.ui.loading = true;
            $ctrl.envelopeId = $stateParams.envelopeId;
            $ctrl.workflow = 'ror';
            //removed rorSteps workflow; handled at parent state
            //$ctrl.workflow = $stateParams.workflow === null ? "" : $stateParams.workflow;
            //var b = "/Agreement?envelopeId=ba309ed6-b63a-453a-874c-4f88a1206a27&event=signing_complete";
            //when returning from docusign below
            if (!$ctrl.userMasterAdvisorAgreement &&
                !!$ctrl.envelopeId &&
                $location.search().event === "signing_complete") {
                
                var envelopeData = { DocusignEnvelopeId: $ctrl.envelopeId };
                agreementsApi.createMasterAdvisorAgreement(envelopeData)
                    .then(function (result) {
                        $ctrl.docIsSigned = true;
                    })
                    .catch(function (error) {
                        console.log(error.data);
                        if (error.data.indexOf('already exists') !== -1) {
                            $ctrl.docIsSigned = true;
                            //$ctrl.ui.showIframe = false;
                        }
                        $ctrl.signError = true;
                    })
                    .finally(function () {
                        $ctrl.ui.loading = false;
                    });
            } else {
                $ctrl.docIsSigned = false;
                $ctrl.ui.loading = false;
            }

        };
    }
})(window.angular, window.app);